import script from "./ProjectsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsComponent.vue?vue&type=style&index=0&id=4cf64943&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf64943"]])

export default __exports__